import * as React from 'react';
import classNames from 'classnames';

import Icon from 'components/icon';

export type InfoCalloutLayout = 'desktop' | 'mobile';

interface InfoCalloutProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  notes?: React.ReactNode;
  /** When true, wraps in the desktop-only widget shell used on s3. */
  inWidget?: boolean;
  layout?: InfoCalloutLayout;
}

/**
 * Side-info card used in the wizard intro column. Mirrors the s3 cutup
 * `c-info` widget with optional supporting image and dashed notes.
 */
export const InfoCallout: React.VFC<InfoCalloutProps> = ({
  title,
  children,
  imageSrc,
  imageAlt = '',
  notes,
  inWidget = true,
  layout = 'desktop',
}) => {
  const info = (
    <div className="c-info">
      <div className="c-info__header">
        <div className="c-info__icon u-text-secondary">
          <Icon name="info" className="o-svg-icon" />
        </div>
        {typeof title !== 'undefined' && <p>{title}</p>}
      </div>
      <div className="c-info__body">
        <div className="c-info__content">
          {children}
          {typeof imageSrc === 'string' && imageSrc.length > 0 && (
            <div>
              <img src={imageSrc} alt={imageAlt} />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const notesBlock =
    typeof notes !== 'undefined' ? (
      <div className="c-notes c-notes--dash">
        <p>{notes}</p>
      </div>
    ) : null;

  if (!inWidget) {
    return (
      <>
        {info}
        {notesBlock}
      </>
    );
  }

  return (
    <div
      className={classNames('c-widget u-mt-spacer-base u-mt-spacer-base-large@lg', {
        'u-hidden u-block@md': layout === 'desktop',
      })}
    >
      <div className="wmax-300">{info}</div>
      {notesBlock}
    </div>
  );
};

export default InfoCallout;
